export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href = 'https://docs.microsoft.com/en-us/microsoft-365/admin/manage/set-password-expiration-policy';
